/**
 * Formats a byte count as a short human-readable size ("512 B", "1.5 KB", "3.2 MB", "1.1 GB").
 * Null or undefined gives "—".
 */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(1)} ${units[unit]}`;
}

/**
 * Formats an amount in the given ISO currency (e.g. "€1,234.50").
 * @param fractionDigits - Fixed number of decimals; 0 for whole amounts in KPI tiles.
 */
export function formatCurrency(amount: number, currency: string, fractionDigits = 2): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}
